package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_checkout.update_template_checkout

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class UpdateTemplateCheckoutModel(
    @SerialName("data")
    val data: Data,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)